var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1818 0H1.45455C0.654545 0 0 0.654545 0 1.45455V11.6364H1.45455V1.45455H10.1818V0ZM12.3636 2.90909H4.36364C3.56364 2.90909 2.90909 3.56364 2.90909 4.36364V14.5455C2.90909 15.3455 3.56364 16 4.36364 16H12.3636C13.1636 16 13.8182 15.3455 13.8182 14.5455V4.36364C13.8182 3.56364 13.1636 2.90909 12.3636 2.90909ZM12.3636 14.5455H4.36364V4.36364H12.3636V14.5455Z",
    fill: "#FCBF07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.08f02106639e9836e23d98c61e93c39b.svg";
export { ForwardRef as ReactComponent };